import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/estoque/estoques/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findEstoques({
  empresa_cnpj,
  id,
  include,
  page,
  where = {},
  fields,
  orwhere = [],
  isSameOrWhere = false,
}) {
  let queryOrWhere = "";
  orwhere.forEach((row, key) => {
    Object.keys(row).forEach((key) => {
      queryOrWhere += `&orwhere${isSameOrWhere ? "[]" : ""}[${key}]=${
        row[key]
      }`;
    });
  });

  let queryWhere = "";
  Object.keys(where).forEach((key) => {
    queryWhere += `&where[${key}]=${where[key]}`;
  });

  return search(
    `${path}${
      id ? `/${id}` : ""
    }?empresa_cnpj=${empresa_cnpj}${queryWhere}${queryOrWhere}${
      include ? `&include=${include}` : ""
    }${page ? `&page=${page}` : ""}${fields ? `&fields${fields}` : ""}`,
    "GET",
    headers
  );
}
